(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HeadMeta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



function HeadMeta(meta) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: meta.title || "".concat(meta.nodeName, " | Mitt Lager")
            }, "title"),
            meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: meta.description
            }, "description"),
            meta.canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: meta.canonical
            })
        ]
    });
}


/***/ }),

/***/ 9841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8527);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3244);
/* harmony import */ var helpers_discounts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2940);






var CampaignBanner = function(param) {
    var campaigns = param.campaigns, campaignLevel = param.campaignLevel, id = param.id, title = param.title;
    var filteredCampaign = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
        return campaign.isActive;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeCampaigns = ref[0], setActiveCampaigns = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeDiscounts = ref1[0], setActiveDiscounts = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), discountIndex = ref2[0], setDiscountIndex = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var sortedCampaigns = [];
        if (campaignLevel === "Top") {
            sortedCampaigns = filteredCampaign === null || filteredCampaign === void 0 ? void 0 : filteredCampaign.filter(function(campaign) {
                return campaign.appliesToAll;
            });
        } else if (campaignLevel === "Facility") {
            sortedCampaigns = filteredCampaign === null || filteredCampaign === void 0 ? void 0 : filteredCampaign.filter(function(campaign) {
                return campaign.appliesToFacilityId.includes(id);
            });
        }
        setActiveCampaigns(sortedCampaigns);
    }, [
        id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.forEach(function(campaign) {
            if (campaign.discounts.length > 0) {
                setActiveDiscounts((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(campaign.discounts)));
            }
        });
    }, [
        activeCampaigns
    ]);
    var titleText = function(discount) {
        var titleText = "JUST NU:";
        if (discount !== undefined) {
            if (campaignLevel === "Facility" && title) {
                titleText = "JUST NU i ".concat(title.toLocaleUpperCase(), " p\xe5 utvalda f\xf6rr\xe5d:");
            }
        }
        return titleText;
    };
    console.log({
        activeCampaigns: activeCampaigns
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.length) > 0 && activeDiscounts.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
            py: 3,
            backgroundColor: constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .colors.system.error[900] */ .O9.system.error[900],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                color: constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .colors.white */ .O9.white,
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                        fontWeight: 600,
                        mr: 3,
                        children: titleText(activeDiscounts[discountIndex])
                    }),
                    " ",
                    (0,helpers_discounts__WEBPACK_IMPORTED_MODULE_5__/* .discountText */ .LT)(activeDiscounts[discountIndex])
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CampaignBanner);


/***/ }),

/***/ 2940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ discountText; },
/* harmony export */   "lk": function() { return /* binding */ getDiscountPrice; },
/* harmony export */   "vN": function() { return /* binding */ getBestDiscount; }
/* harmony export */ });
/* unused harmony export checkAvailbleDiscounts */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);

var checkAvailbleDiscounts = function(campaigns, campaignLevel, facilityId, unitId) {
    var activeCampaigns = [];
    var activeDiscounts = [];
    if (campaignLevel === "Top") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToAll;
        });
    } else if (campaignLevel === "Facility") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToFacilityId.includes(facilityId);
        });
    } else if (campaignLevel === "Unit") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToAll || campaign.appliesToFacilityId.includes(facilityId);
        });
    }
    if (campaignLevel === "Unit") {
        activeCampaigns.forEach(function(campaign) {
            return activeDiscounts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(campaign.discounts.filter(function(discount) {
                return discount.appliesToAll || discount.appliesToProductId.includes(unitId);
            })));
        });
    } else {
        activeCampaigns.forEach(function(campaign) {
            return activeDiscounts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(campaign.discounts));
        });
    }
    return activeDiscounts;
};
var calcuteDiscountedPrice = function(price, discount) {
    return discount.discountType === "fixed" ? price - discount.amountOff : price * (1 - discount.percentOff / 100);
};
var getDiscountPrice = function(price, discount) {
    var returnPrice = price;
    var discountPrice = calcuteDiscountedPrice(price, discount);
    if (discountPrice < returnPrice) {
        returnPrice = discountPrice > 0 ? discountPrice : 0;
    }
    return Math.round(returnPrice * 100) / 100;
};
var getBestDiscount = function(price, discounts) {
    var returnDiscount;
    discounts.forEach(function(discount) {
        if (returnDiscount === undefined) {
            returnDiscount = discount;
        } else {
            var currentDiscountPrice = calcuteDiscountedPrice(price, returnDiscount);
            if (currentDiscountPrice > calcuteDiscountedPrice(price, discount)) {
                returnDiscount = discount;
            }
        }
    });
    return returnDiscount;
};
var discountText = function(discount) {
    if (discount !== undefined) {
        var val = "kr";
        if (discount.discountType === "percent") {
            val = "%";
        }
        var length = "under din f\xf6rsta m\xe5nad";
        if (!discount.includeFirstMonth) {
            length = "under din f\xf6rsta hela m\xe5nad";
        }
        if (discount.discountedMonths > 0) {
            length = "under ".concat(discount.discountedMonths, " m\xe5nader");
        }
        var condition = "";
        if (discount.requireFirstOrder) {
            condition = ", g\xe4ller endast nya kunder";
        }
        return "".concat(discount.discountType === "percent" ? discount.discountValue : discount.amountOff).concat(val, " rabatt ").concat(length).concat(condition, ".");
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (checkAvailbleDiscounts);


/***/ }),

/***/ 5082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./helpers/umbracoApi.tsx + 17 modules
var umbracoApi = __webpack_require__(3767);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/umbraco/HeroBlock.tsx
var HeroBlock = __webpack_require__(3910);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/chakra-ui-tooltip.esm.js
var chakra_ui_tooltip_esm = __webpack_require__(7398);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./constants/constants.tsx
var constants = __webpack_require__(3244);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 39 modules
var react_select_browser_esm = __webpack_require__(6595);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(9876);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./constants/_reactSelect.ts
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 


var colourStyles = {
    // outer container of the input area
    control: function(styles, param) {
        var isFocused = param.isFocused;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
            paddingLeft: 40,
            paddingRight: 85,
            borderRadius: 45,
            height: 90,
            cursor: "pointer",
            border: isFocused ? 0 : 0,
            boxShadow: isFocused ? 0 : 0,
            "&:hover": {
                border: isFocused ? 0 : 0
            }
        });
    },
    // an ugly line separating the icon area from the input area
    // we are not using this
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    // the standard chevron dropdown icon
    // we are not using this
    dropdownIndicator: function() {
        return {
            display: "none"
        };
    },
    // the X used to clear input
    // we are not using this!
    clearIndicator: function() {
        return {
            display: "none"
        };
    },
    // the outer container of all the options
    menu: function(styles) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
            padding: 20,
            borderRadius: "1em",
            zIndex: "10"
        });
    },
    // the inner container of all the options
    menuList: function() {
        return {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
            justifyContent: "space-between",
            "@media (min-width: 640px)": {
                flexDirection: "row"
            }
        };
    },
    option: function(_, param) {
        var isFocused = param.isFocused, isSelected = param.isSelected;
        return {
            fontWeight: isSelected || isFocused ? "bold" : "normal",
            cursor: "pointer",
            color: isSelected ? constants/* colors.secondary.900 */.O9.secondary[900] : isFocused ? constants/* colors.primary.900 */.O9.primary[900] : constants/* colors.secondary.900 */.O9.secondary[900],
            backgroundColor: isFocused ? "transparent" : "transparent",
            marginBottom: ".5em",
            "&:last-of-type": {
                border: 0,
                marginBottom: 0
            },
            "@media (min-width: 640px)": {
                flex: "1 0 calc(50% - 1em)",
                borderBottom: "1px solid " + constants/* colors.secondary.500 */.O9.secondary[500],
                paddingBottom: ".5em",
                "&:nth-of-type(even)": {
                    marginLeft: "1em"
                },
                "&:last-of-type": {
                    border: 0
                }
            }
        };
    },
    // the input / typing
    input: function() {
        return {
            paddingTop: 28,
            fontSize: 20,
            maxWidth: "75%",
            overflow: "hidden",
            "& input": {
                fontWeight: "bold"
            }
        };
    },
    // the placeholder text
    placeholder: function() {
        return {
            position: "absolute",
            fontSize: 20,
            paddingTop: 28,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "100%",
            fontWeight: "bold",
            opacity: 0.5
        };
    },
    // the value in the input field after selecting a value
    singleValue: function() {
        return {
            position: "absolute",
            fontSize: 20,
            paddingTop: 28,
            fontWeight: "bold",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "100%"
        };
    }
};

;// CONCATENATED MODULE: ./components/booking/Booking.tsx








function Booking(param) {
    var facilities = param.facilities;
    var ref = (0,react.useState)(), selectedFacility = ref[0], setSelectedFacility = ref[1];
    var ref1 = (0,react.useState)(facilities[0] ? facilities[0].name : null), placeholder = ref1[0], setPlaceholder = ref1[1];
    var ref2 = (0,react.useState)(false), menuIsOpen = ref2[0], setMenuIsOpen = ref2[1];
    var router = (0,next_router.useRouter)();
    var handleFacilityClick = function(e) {
        router.push("/anlaggning/".concat(e.value));
    };
    (0,react.useEffect)(function() {
        var ref;
        setPlaceholder((ref = facilities[Math.floor(Math.random() * facilities.length)]) === null || ref === void 0 ? void 0 : ref.name);
    }, [
        facilities
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        w: "100%",
        maxW: "lg",
        mt: "10",
        pos: "relative",
        onClick: function() {
            return setMenuIsOpen(!menuIsOpen);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                inputId: "bookingSelect",
                id: "bookingSelect",
                isClearable: true,
                value: selectedFacility,
                styles: colourStyles,
                placeholder: facilities ? placeholder : "...",
                onChange: function(e) {
                    return handleFacilityClick(e);
                },
                options: facilities.map(function(x) {
                    return {
                        value: x.slug,
                        label: x.name
                    };
                }),
                menuIsOpen: menuIsOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                htmlFor: "bookingSelect",
                variant: "reactSelectLabel",
                children: "Visa f\xf6rr\xe5d i"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_tooltip_esm/* Tooltip */.u, {
                hasArrow: true,
                label: menuIsOpen ? "Klicka f\xf6r att komma till en anl\xe4ggning" : "Se v\xe5ra anl\xe4ggningar",
                variant: "reactSelectTooltip",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                    onClick: function() {
                        return setMenuIsOpen(!menuIsOpen);
                    },
                    variant: "bookingBtn",
                    "aria-label": "Visa f\xf6rr\xe5d i ".concat(selectedFacility === null || selectedFacility === void 0 ? void 0 : selectedFacility.label),
                    _hover: {
                        bg: constants/* colors.system.success.300 */.O9.system.success[300]
                    },
                    children: menuIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {
                        w: "3em",
                        h: "3em"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronRightIcon */.XC, {
                        w: "3em",
                        h: "3em"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var booking_Booking = (Booking);

// EXTERNAL MODULE: ./components/HeadMeta.tsx
var HeadMeta = __webpack_require__(3636);
// EXTERNAL MODULE: ./components/campaigns/CampaignBanner.tsx
var CampaignBanner = __webpack_require__(9841);
;// CONCATENATED MODULE: ./pages/index.tsx









var __N_SSG = true;
function Home(param) {
    var sharedPageProps = param.sharedPageProps, productsByFacility = param.productsByFacility, blocks = param.blocks, meta = param.meta;
    var ref;
    var firstBlockIsHeroBlock = (blocks === null || blocks === void 0 ? void 0 : (ref = blocks[0]) === null || ref === void 0 ? void 0 : ref.contentTypeAlias) === "HeroBlock";
    console.log("from index.ts", sharedPageProps);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMeta/* HeadMeta */.N, (0,_object_spread/* default */.Z)({}, meta)),
            firstBlockIsHeroBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBlock/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blocks[0]), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(booking_Booking, {
                    facilities: sharedPageProps.facilities,
                    productsByFacility: productsByFacility
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBanner/* default */.Z, {
                campaigns: sharedPageProps.campaigns,
                campaignLevel: "Top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(umbracoApi/* BlockRenderer */.HO, {
                blocks: blocks === null || blocks === void 0 ? void 0 : blocks.slice(firstBlockIsHeroBlock ? 1 : 0)
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [563,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);